export default "__VITE_ASSET__BRmE2jyP__"